import {
  LOCATION_ALL,
  LOCATION_GET,
  LOCATION_PUT,
  LOCATION_DEL,
  LOCATION_POST,
  LOCATION_LOADING,
  LOCATION_ERROR,
} from '../../actions/types';

const initialState = {
  location: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case LOCATION_LOADING:
      return { isLoading: true, isCompleted: true };
    case LOCATION_ERROR:
      return { isLoading: false, isCompleted: false };
    case LOCATION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case LOCATION_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case LOCATION_POST:
      return { isLoading: false, isCompleted: true };
    case LOCATION_PUT:
      return { isLoading: false, isCompleted: true };
    case LOCATION_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
